/* Native /cart remains the fallback; reload after a service change so its
 * server-rendered prices and quantity fields always match the actual cart. */
(() => {
  const root=document.querySelector('[data-ywr-full-cart]');
  const option=root?.querySelector('[data-ywr-protection]');
  if(!root || !option || !window.YWRShippingProtection)return;
  const base=root.dataset.rootUrl || '/',form=document.getElementById('cart');
  if(!form)return;
  const toggle=option.querySelector('[data-ywr-protection-toggle]');
  const status=root.querySelector('[data-ywr-full-cart-status]');
  const config={variantId:option.dataset.variantId,priceCents:Number(option.dataset.priceCents),handle:option.dataset.handle};
  async function request(path,body) {
    const response=await fetch(base+path,{method:body===undefined?'GET':'POST',credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json',...(body===undefined?{}:{'Content-Type':'application/json'})},...(body===undefined?{}:{body:JSON.stringify(body)})});
    const data=await response.json();if(!response.ok)throw new Error('We could not confirm shipping protection. Please refresh your cart.');return data;
  }
  const service=window.YWRShippingProtection.create({read:()=>request('cart.js'),post:request,product:handle=>request('products/'+encodeURIComponent(handle)+'.js')},config);
  const fingerprint=cart=>JSON.stringify({items:cart.items.map(item=>[item.key,item.quantity,item.final_line_price]),total:cart.total_price});
  let busy=false;
  function lock(value){busy=value;root.inert=value;form.inert=value;root.setAttribute('aria-busy',String(value));}
  async function update(choice) {
    if(busy)return;
    lock(true);status.textContent='Confirming your cart…';
    let before;
    try {
      before=await request('cart.js');
      const after=await service.reconcile(choice);
      if(fingerprint(before)!==fingerprint(after)){location.reload();return;}
      const state=service.view(after);option.hidden=!state.visible;toggle.checked=state.selected;
      const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:after.currency||'USD'});
      option.querySelector('[data-ywr-protection-price]').textContent=money.format((state.selected?state.cents:config.priceCents)/100);
      status.textContent='';lock(false);
      root.querySelector('[name="checkout"]').disabled=!after.items.some(item=>!service.isService(item));
    } catch(error) {
      try {
        const after=await request('cart.js');
        if(before && fingerprint(before)!==fingerprint(after)){location.reload();return;}
        const state=service.view(after);option.hidden=!state.visible;toggle.checked=state.selected;
        // If no service charge exists, leave the ordinary native checkout usable.
        if(!state.selected){lock(false);toggle.disabled=true;}
      } catch(_) {}
      status.textContent=error.message;
    }
  }
  toggle.addEventListener('change',()=>update(toggle.checked));
  form.addEventListener('submit',event=>{if(busy)event.preventDefault();});
  if(typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,()=>update());
  update();
})();
